import React, { useEffect, useRef, isTablet } from "react";
import Chart from "chart.js";
import { customTooltips } from "../../../new/Utils/customTooltips";

const LineChart = ({ bardData, isMobile, isTablet }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const options = {
      hover: {
        mode: 'nearest',
        intersect: true,
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: true,
          },
          ticks: {
            fontColor: 'black',
            fontSize: isTablet ? 13 : isMobile ? 10 : 15,// Adjust font size based on isMobile prop
          },
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
            max: 10,
            stepSize: 2,
            fontSize: isTablet ? 13 : isMobile ? 10 : 15, // Adjust font size based on isMobile prop
          },
        }],
      },
      legend: {
        display: true,
        position: "top",
        align: "end",
        labels: {
          padding: 20,
          boxWidth: 15,
          margin: 0,
          fontSize: isMobile ? 12 : 16, // Adjust font size based on isMobile prop
        },
      },
      tooltips: {
        enabled: false,
        custom: customTooltips,
        callbacks: {
          title: function (tooltipItem, data) {
            const datasetIndex = tooltipItem[0].datasetIndex;
            return data.datasets[datasetIndex].label;
          },
          label: function (tooltipItem, data) {
            const value = tooltipItem.yLabel;
            return `${value}`;
          }
        }
      },
      elements: {
        line: {
          tension: 0, // Disables bezier curves
        },
      },
      animation: {
        duration: 0, // Disable animations
      },
    };

    const ctx = chartRef.current.getContext("2d");
    // Create the chart instance
    let chartInstance = new Chart(ctx, {
      type: "line",
      data: bardData,
      options: options,
    });

    // Cleanup
    return () => {
      chartInstance.destroy();
    };
  }, [bardData, isMobile]); // Add isMobile to the dependency array

  return (
    <canvas
      width={isMobile ? '300' : isTablet ? '400' : undefined}
      height={isMobile ? '280' : isTablet ? '300' : undefined}
      ref={chartRef}
    />
  );
};

export default LineChart;


// WEBPACK FOOTER //
// ./src/_components/common/LineChart/LineChart.jsx